import { withRouter } from '@hoc/withRouter';
import store from '@redux/store';
import React from 'react';
import { Provider } from 'react-redux';
export function withRedux(WrappedComponent) {
    const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    const ComponentWithRedux = (props) => {
        return (React.createElement(Provider, { store: store },
            React.createElement(WrappedComponent, { ...props })));
    };
    ComponentWithRedux.displayName = `withRedux(${displayName})`;
    return withRouter(ComponentWithRedux);
}
